module.exports = __webpack_public_path__ + "img/contact99.6f41bed9.jpg";